import type { IconData } from '@stacksjs/iconify-core'

export const toiletWomen: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M14.332 34.74c-1.782-.103-3.013-1.77-2.526-3.488c1.563-5.515 3.88-10.377 5.193-12.905c.618-1.192 1.739-2.023 3.075-2.161c.969-.1 2.278-.186 3.926-.186s2.957.085 3.927.186c1.335.138 2.456.97 3.075 2.161c1.312 2.528 3.63 7.39 5.192 12.905c.487 1.717-.744 3.385-2.526 3.487c-.828.047-1.798.095-2.898.137l-.583 7.29c-.11 1.371-1.14 2.493-2.51 2.632c-1.06.107-2.368.202-3.677.202s-2.617-.095-3.677-.202c-1.37-.14-2.4-1.26-2.51-2.633l-.583-7.29c-1.1-.04-2.07-.089-2.898-.136Z\"/><path d=\"M17.5 9.5a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0-13 0M24 36v9\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default toiletWomen
